export class UtenteSocieta {
    utenteId: string = "";
    societaId: number = 0;
}